import { render, staticRenderFns } from "./ColorBlock.vue?vue&type=template&id=64a8521d&"
import script from "./ColorBlock.vue?vue&type=script&lang=js&"
export * from "./ColorBlock.vue?vue&type=script&lang=js&"
import style0 from "./ColorBlock.vue?vue&type=style&index=0&id=64a8521d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports